import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import './styles/theme.css';
import './index.css';
import { StoreProvider } from './context/StoreContext';
import PublicLayout from './components/PublicLayout';
import MenuPage from './pages/MenuPage';
import CheckoutPage from './pages/CheckoutPage';
import ReservationPage from './pages/ReservationPage';
import TrackingPage from './pages/TrackingPage';
import AccountPage from './pages/AccountPage';
import DineInPage from './pages/DineInPage';
import KitchenPage from './staff/KitchenPage';
import CashierPage from './staff/CashierPage';
import ServicePage from './staff/ServicePage';
import Admin from './Admin';

// Compatibilité avec les anciennes URLs en #hash (liens enregistrés, QR codes…)
function HashRedirect({ children }) {
  const navigate = useNavigate();

  React.useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;
    if (hash === '#admin') navigate('/admin', { replace: true });
    else if (hash === '#reservation') navigate('/reserver', { replace: true });
    else if (hash.startsWith('#order/')) navigate(`/suivi/${hash.split('/')[1]}`, { replace: true });
  }, [navigate]);

  return children;
}

// Remonte en haut à chaque changement de page (sinon on arrive scrollé en bas)
function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <HashRedirect>
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/table/:qrToken" element={<DineInPage />} />
          <Route path="/cuisine" element={<KitchenPage />} />
          <Route path="/caisse" element={<CashierPage />} />
          <Route path="/service" element={<ServicePage />} />
          <Route element={<PublicLayout />}>
            <Route path="/" element={<MenuPage />} />
            <Route path="/commande" element={<CheckoutPage />} />
            <Route path="/reserver" element={<ReservationPage />} />
            <Route path="/suivi/:token" element={<TrackingPage />} />
            <Route path="/fidelite" element={<AccountPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </HashRedirect>
    </BrowserRouter>
  );
}

// Service worker : notifications push de l'administration
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StoreProvider>
      <AppRouter />
    </StoreProvider>
  </React.StrictMode>
);
